import React, { useCallback } from 'react';
import Picon from '@piconetworks/pkg-picon';
import styles from './Vcard.module.scss.js';

var DefaultContactInfo = function DefaultContactInfo() {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Picon, {
    icon: "icon_save_to_phone",
    size: "24",
    color: "#120A20"
  }), /*#__PURE__*/React.createElement("h3", null, "Save contact info"));
};
var VcardBlock = function VcardBlock(_ref) {
  var children = _ref.children,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;
    _ref.className;
  var onClick = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    _onClick();
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    ontouchstart: "",
    className: styles.vcard + " block"
  }, /*#__PURE__*/React.createElement("a", {
    className: "" + styles.link,
    href: '#',
    target: "_blank",
    onClick: onClick
  }, children || /*#__PURE__*/React.createElement(DefaultContactInfo, null)));
};

export { VcardBlock as default };
//# sourceMappingURL=index.js.map
